import { render } from "./HotelsInline.vue?vue&type=template&id=a619c462"
import script from "./HotelsInline.vue?vue&type=script&lang=js"
export * from "./HotelsInline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__